<!-- eslint-disable max-len -->
<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 3L7 3C4.79086 3 3 4.79086 3 7L3 25C3 27.2091 4.79086 29 7 29L25 29C27.2091 29 29 27.2091 29 25L29 6.99999C29 4.79086 27.2091 3 25 3ZM5 7C5 5.89543 5.89543 5 7 5L25 5C26.1046 5 27 5.89543 27 7L27 25C27 26.1046 26.1046 27 25 27L7 27C5.89543 27 5 26.1046 5 25L5 7ZM7 20C7 19.4477 7.44772 19 8 19L14 19C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21L8 21C7.44772 21 7 20.5523 7 20ZM8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17L19 17C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15L8 15ZM7 12C7 11.4477 7.44772 11 8 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L8 13C7.44772 13 7 12.5523 7 12ZM7 8C7 7.44771 7.44772 7 8 7L19 7C19.5523 7 20 7.44771 20 8C20 8.55228 19.5523 9 19 9L8 9C7.44772 9 7 8.55228 7 8Z"
      fill="currentColor"
    />
  </svg>
</template>
